import PropTypes from 'prop-types';
import { zhTW } from 'react-day-picker/locale';

import { cn } from '#/lib/utils';
import { Calendar as ShadcnCalendar } from '#/modules/commonComponents/shadcn/ui/calendar';

const CALENDAR_WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];

const DEFAULT_CALENDAR_YEAR_SPAN = {
  yearsBefore: 20,
  yearsAfter: 5,
};

const DEFAULT_CALENDAR_FORMATTERS = {
  formatCaption: (date) => `${date.getFullYear()}年${date.getMonth() + 1}月`,
  formatMonthDropdown: (date) => `${date.getMonth() + 1}月`,
  formatYearDropdown: (date) => `${date.getFullYear()}年`,
  formatWeekdayName: (date) => CALENDAR_WEEKDAYS[date.getDay()],
};

function resolveCalendarMonthBounds({ startMonth, endMonth } = {}) {
  const now = new Date();
  const resolvedStart = startMonth ?? new Date(
    now.getFullYear() - DEFAULT_CALENDAR_YEAR_SPAN.yearsBefore,
    0,
    1,
  );
  const resolvedEnd = endMonth ?? new Date(
    now.getFullYear() + DEFAULT_CALENDAR_YEAR_SPAN.yearsAfter,
    11,
    1,
  );

  return {
    startMonth: resolvedStart,
    endMonth: resolvedEnd,
  };
}

/**
 * shadcn Calendar 薄包裝（業務勿直接 import shadcn/ui/calendar）。
 * 預設 zh-TW、captionLayout=dropdown、可選年區間。
 */
const Calendar = ({
  className,
  locale = zhTW,
  formatters,
  captionLayout = 'dropdown',
  startMonth,
  endMonth,
  ...props
}) => {
  const monthBounds = resolveCalendarMonthBounds({ startMonth, endMonth });

  return (
    <ShadcnCalendar
      className={cn('text-sm', className)}
      locale={locale}
      captionLayout={captionLayout}
      startMonth={monthBounds.startMonth}
      endMonth={monthBounds.endMonth}
      formatters={{
        ...DEFAULT_CALENDAR_FORMATTERS,
        ...formatters,
      }}
      {...props}
    />
  );
};

Calendar.propTypes = {
  className: PropTypes.string,
  locale: PropTypes.object,
  formatters: PropTypes.object,
  captionLayout: PropTypes.oneOf(['label', 'dropdown', 'dropdown-months', 'dropdown-years']),
  startMonth: PropTypes.instanceOf(Date),
  endMonth: PropTypes.instanceOf(Date),
};

export default Calendar;
